export const FEED_UPDATE_LIST = 'FEED_UPDATE_LIST'
export const FEED_UPDATE_LIST_METHOD = 'FEED_UPDATE_LIST_METHOD'

export const updateFeedsList = ({ data, count }) => ({
  type: FEED_UPDATE_LIST,
  payload: { data, count }
})
export const updateFeedsListMethod = (method, data) => ({
  type: FEED_UPDATE_LIST_METHOD,
  payload: { method, data }
})